import type { AchievementId, ProgressStats } from './types'

export type AchievementDef = {
  id: AchievementId
  gemReward: number
}

export const ACHIEVEMENTS: AchievementDef[] = [
  { id: 'first_100_food_collected', gemReward: 25 },
  { id: 'first_den_bosch_trip', gemReward: 15 },
  { id: 'first_5_crafts', gemReward: 20 },
  { id: 'out_the_door', gemReward: 5 },
  { id: 'strength_in_numbers', gemReward: 20 },
  { id: 'full_house', gemReward: 35 },
  { id: 'on_four_wheels', gemReward: 20 },
  { id: 'new_home', gemReward: 25 },
  { id: 'signal_found', gemReward: 30 },
  { id: 'water_bearer', gemReward: 20 },
  { id: 'workshop_regular', gemReward: 25 },
  { id: 'street_wise', gemReward: 20 },
  { id: 'blooded', gemReward: 10 },
]

export function resolveUnlockedAchievements(
  stats: ProgressStats,
  alreadyUnlocked: AchievementId[],
): AchievementId[] {
  const unlocked = new Set(alreadyUnlocked)
  if (stats.totalFoodCollected >= 100) unlocked.add('first_100_food_collected')
  if (stats.denBoschTripsCompleted >= 1) unlocked.add('first_den_bosch_trip')
  if (stats.totalCraftsCompleted >= 5) unlocked.add('first_5_crafts')
  if (stats.totalExpeditionsCompleted >= 1) unlocked.add('out_the_door')
  if (stats.survivorsRecruited >= 3) unlocked.add('strength_in_numbers')
  if (stats.survivorsRecruited >= 6) unlocked.add('full_house')
  if (stats.vehiclesFound >= 1) unlocked.add('on_four_wheels')
  if (stats.hideoutMoves >= 1) unlocked.add('new_home')
  if (stats.radioBuilt) unlocked.add('signal_found')
  if (stats.totalWaterCollected >= 100) unlocked.add('water_bearer')
  if (stats.totalCraftsCompleted >= 25) unlocked.add('workshop_regular')
  if (stats.denBoschTripsCompleted >= 10) unlocked.add('street_wise')
  if (stats.totalInjuries >= 1) unlocked.add('blooded')
  return Array.from(unlocked)
}

export function gemRewardForAchievement(id: AchievementId): number {
  return ACHIEVEMENTS.find((def) => def.id === id)?.gemReward ?? 0
}
